import React from "react";

const NivelesCard = ({color , nivel, info}) => {
  return (
    <div className={`h-fit bg-white rounded-lg rounded-tl-none shadow-[-10px_10px_0px_0px_#0D2334] border-solid border-4 border-primario`}>
      <h3 style={{background:`${color}`}} className={`text-4xl text-white font-Bebas p-5 rounded-none `}>{nivel}</h3>
      <p className="text-lg p-5 hyphens-none">
        {info}
      </p>
    </div>
  );
};

export default NivelesCard;
